import { dehydrate } from '@tanstack/react-query'
import { getProps } from 'ssr/getProps'
import { runWithAmplifyServerContext, serverClient } from 'web-amplify/server'

import { searchMapsQuery } from '~map-search/api/searchMaps'
import { getQuery } from '~map-search/helpers/getQuery'
import { getSort } from '~map-search/helpers/getSort'
import { getTagIds } from '~map-search/helpers/getTagIds'
import { getGeolocationKey } from '~map-search/queries/useGetGeolocation'
import { getSearchMapsKey } from '~map-search/queries/useSearchMaps'
import { Feed_Types } from '~map-search/types/__generated/gql/graphql'
import { initialNumToRender } from '../Main/VirtualizedMapGrid'

const toFloat = (value) => parseFloat(String(value))
const getLat = (req) => req?.headers['cloudfront-viewer-latitude']
const getLng = (req) => req?.headers['cloudfront-viewer-longitude']

export const fn = async (context, client, props) => {
  const { req, res } = context

  res?.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  )

  const lat = getLat(req)
  const lng = getLng(req)

  const coords = {
    lat: toFloat(lat) || 0,
    lng: toFloat(lng) || 0
  }

  const feedType = getSort(context.query.sort)
  const tagIds = getTagIds(context.query.tags)
  const query = getQuery(context.query.keywords)

  const key = {
    feedType,
    tagIds,
    query,
    ...(feedType === Feed_Types.Near && {
      coords
    })
  }

  let data
  try {
    const result = (await runWithAmplifyServerContext({
      nextServerContext: { request: context.req, response: context.res },
      operation: async (ctx) =>
        serverClient.graphql(ctx, {
          query: searchMapsQuery,
          variables: key,
          ...(props?.authenticated
            ? { authMode: 'userPool', authToken: props.token! }
            : { authMode: 'apiKey' })
        })
    })) as any

    data = result?.data
  } catch (error) {
    // no catching
  }

  await Promise.all([
    client.prefetchQuery({
      queryKey: getGeolocationKey(),
      queryFn: () => coords
    }),

    client.prefetchInfiniteQuery({
      queryKey: getSearchMapsKey(key),
      queryFn: () => data,
      initialPageParam: {
        from: 0,
        size: initialNumToRender
      }
    })
  ])

  return {
    props: {
      dehydratedState: dehydrate(client)
    }
  }
}

export const getServerSideProps = getProps(fn)
